module.exports = __webpack_public_path__ + "img/frame (119).14c5fec8.jpg";